(function () {
  function init(section) {
    var slots = section.querySelectorAll('[data-urb-qp-group]');
    var dots = section.querySelectorAll('[data-urb-qp-dots] .urb-qp__dot');
    if (!slots.length) return;

    var supportsViewTimeline =
      typeof CSS !== 'undefined' &&
      CSS.supports &&
      CSS.supports('animation-timeline', 'view()');

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var index = Array.prototype.indexOf.call(slots, entry.target);
          if (index === -1) return;
          if (entry.isIntersecting) {
            dots.forEach(function (d, i) {
              d.classList.toggle('is-active', i === index);
            });
            if (!supportsViewTimeline) {
              entry.target.classList.add('is-active');
            }
          } else if (!supportsViewTimeline) {
            entry.target.classList.remove('is-active');
          }
        });
      },
      { threshold: 0.5 }
    );

    slots.forEach(function (slot) {
      io.observe(slot);
    });
  }

  function boot() {
    document.querySelectorAll('[data-urb-qp]').forEach(init);
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-urb-qp]');
    if (el) init(el);
  });
})();
